import React, { Component, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";
// import "./loading.scss";

import {
  AppAside,
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav,
} from "@coreui/react";
// sidebar nav config
import navigation from "../../_nav";
// routes config
import routes from "../../routes";
import { connect } from "react-redux";
import Notification from "../../components/Notification/Notification";
import { reauth, getUserToken, getUserData } from "../../libs/authentication";
import NotificationSubscriber from "../../contexts/NotificationSubsrciber/NotificationSubscriber";
import AuthorizationSchema from "../../authorization ";

const DefaultAside = React.lazy(() => import("./DefaultAside"));
const DefaultFooter = React.lazy(() => import("./DefaultFooter"));
const DefaultHeader = React.lazy(() => import("./DefaultHeader"));

class DefaultLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingUserData: false,
      notificationOpen: false,
    };
  }
  loading = () => (
    <div className="flex">
      <div className="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );

  signOut(e) {
    e.preventDefault();
    window.location.reload(this.props.history.push("/login"));
    localStorage.clear("_dentonslogin");
    localStorage.clear("_dentonslogintoken");
  }
  componentDidUpdate(prevprops, prevstate, snapshot) {
    /** Bypass user data check ONLY IF loadingUserData is changed */
    if (prevstate.loadingUserData != this.state.loadingUserData) return;

    // this.checkUserData();
  }
  componentDidMount() {
    this.checkUserData();
  }
  async checkUserData() {
    if (this.state.loadingUserData) return;
    try {
      this.setState({
        loadingUserData: true,
      });
      let token = await reauth();
      if (!token) {
        this.props.history.push("/login");
      }
    } catch (error) {
      console.log(error);
      this.props.history.push("/login");
    } finally {
      setTimeout(() => {
        this.setState({
          loadingUserData: false,
        });
      }, 500);
    }
  }
  populateAuthorizationData(schema = AuthorizationSchema) {
    const authSchema = [];
    for (let authItem of schema) {
      if (authItem.hasOwnProperty("url")) {
        authSchema.push({
          name: authItem.name,
          url: authItem.url,
          resps: authItem.resps,
        });
      }
      if (authItem.hasOwnProperty("children")) {
        for (let authItemChildren of this.populateAuthorizationData(
          authItem.children
        )) {
          authSchema.push({
            name: authItemChildren.name,
            url: authItemChildren.url,
            resps: authItemChildren.resps,
          });
        }
      }
    }
    return authSchema;
  }
  logAll(nav) {
    for (let n of nav) {
      const { name } = n;
      // console.log(name);
      if (n.children) {
        this.logAll(n.children);
      }
    }
  }
  searchForAuthSchemaUrl(name) {
    const nav = navigation.items;
    let searchResult = null;
    // window.nav = nav;
    // window.navsearch = this.recursiveCheckAuthSchema.bind(this);
    searchResult = this.recursiveCheckAuthSchema(nav, name);
    if (searchResult) {
      return this.checkForUserRespAllowance(searchResult);
    } else {
      return true;
    }
  }
  recursiveCheckAuthSchema(nav, name, depth = 0) {
    let searchResult = null;
    for (let n of nav) {
      // console.log(n.url);
      if (n.url && name == n.url) {
        // console.log(`MATCH NAME`);
        searchResult = n;
        break;
      } else if (n.children) {
        // console.log(`NO MATCH. Recursive Search`);
        searchResult = this.recursiveCheckAuthSchema(n.children, name);
        if (searchResult != null) break;
      }
    }
    return searchResult;
  }
  checkForUserRespAllowance(schema) {
    if (typeof schema.resps == "undefined") {
      schema.err = "resps settings is undefined";
      return true;
    }
    if (!this.user) this.user = getUserData();
    const user = this.user;
    if (!user) return false;
    if ((user && user.user_code == "SUPERADMIN") || user.user_code == "NWS")
      return true;
    if (!user.hasOwnProperty("responsibilities")) {
      schema.err = "User has no responsibilities";
      return false;
    }

    const resps = [user.user_code];

    user.responsibilities.forEach((x) => {
      resps.push(x.responsibility_code);
    });

    schema.searchResps = resps;
    for (let resp of resps) {
      const exceptionUser = schema.resps.filter((code) => code.includes("!"));
      // console.log(
      //   exceptionUser,
      //   exceptionUser.indexOf("!" + user.user_code) >= 0
      // );
      if (
        schema.resps.indexOf(resp) >= 0 &&
        exceptionUser.length >= 0 &&
        exceptionUser.indexOf("!" + user.user_code) < 0
      ) {
        return true;
      } else if (
        exceptionUser.length >= 1 &&
        exceptionUser.indexOf("!" + user.user_code) >= 0
      ) {
        return false;
      }
    }
    return false;
  }
  filterNavigation(navigation) {
    const filteredNavigation = [];
    if (typeof this.authSchema == "undefined") {
      this.authSchema = this.populateAuthorizationData(AuthorizationSchema);
    }

    for (let nav of navigation) {
      let allow = false;
      let authSchema = null;
      if (nav.hasOwnProperty("resps")) {
        allow = this.checkForUserRespAllowance(nav);
      } else {
        allow = true;
      }

      if (allow) {
        const newNav = {
          ...nav,
          children: null,
          schema: authSchema,
        };
        if (nav.hasOwnProperty("children")) {
          newNav.children = this.filterNavigation(nav.children);
          // if (newNav.children.length < 1) newNav.children = null;
        }
        filteredNavigation.push(newNav);
      }
    }

    return filteredNavigation;
  }
  render() {
    const respNav = this.filterNavigation(navigation.items);

    let filteredNavigation = { items: respNav };
    // console.log(filteredNavigation);
    let { notificationOpen, loadingUserData } = this.state;
    return (
      <div className="app">
        <AppHeader fixed>
          <Suspense fallback={this.loading()}>
            <DefaultHeader
              loadingUserData={loadingUserData}
              notifClick={() => {
                this.setState({
                  notificationOpen: true,
                });
              }}
              onLogout={(e) => this.signOut(e)}
            />
          </Suspense>
        </AppHeader>
        <div
          className={
            "app-body " + (this.props.control.boardMode ? "boardmode" : "")
          }
        >
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <Suspense>
              <AppSidebarNav navConfig={filteredNavigation} {...this.props} />
            </Suspense>
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>
          <main className="main">
            {notificationOpen ? (
              <Notification
                closeNotification={() => {
                  this.setState({
                    notificationOpen: false,
                  });
                }}
                notificationOpen={notificationOpen}
              />
            ) : null}
            <AppBreadcrumb appRoutes={routes} />
            <Container fluid>
              <NotificationSubscriber />
              <Suspense fallback={this.loading()}>
                <Switch>
                  {routes.map((route, idx) => {
                    let allowAccess = this.searchForAuthSchemaUrl(route.path);
                    if (!allowAccess) return null;
                    return route.component ? (
                      <Route
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={(props) => <route.component {...props} />}
                      />
                    ) : null;
                  })}
                  <Redirect from="/" to="/login" />
                </Switch>
              </Suspense>
            </Container>
          </main>
          <AppAside fixed>
            <Suspense fallback={this.loading()}>
              <DefaultAside />
            </Suspense>
          </AppAside>
        </div>
        <AppFooter>
          <Suspense fallback={this.loading()}>
            <DefaultFooter />
          </Suspense>
        </AppFooter>
      </div>
    );
  }
}

export default connect((store) => ({
  control: store.ViewControl,
}))(DefaultLayout);
